import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from '@/locales/en/common.json';
import zhCommon from '@/locales/zh/common.json';

import {
  DEFAULT_LANGUAGE,
  FALLBACK_LANGUAGE,
  loadPersistedLanguage,
  normalizeLanguage,
  persistLanguage,
  SUPPORTED_LANGUAGES,
} from './language';

const resources = {
  en: { common: enCommon },
  zh: { common: zhCommon },
} as const;

let initialized = false;

export const initializeI18n = async () => {
  if (initialized || i18n.isInitialized) {
    return i18n;
  }

  await i18n.use(initReactI18next).init({
    resources,
    lng: loadPersistedLanguage(),
    fallbackLng: FALLBACK_LANGUAGE,
    defaultNS: 'common',
    ns: ['common'],
    supportedLngs: [...SUPPORTED_LANGUAGES],
    interpolation: {
      escapeValue: false,
    },
  });

  initialized = true;

  i18n.on('languageChanged', language => {
    persistLanguage(normalizeLanguage(language));
  });

  // Ensure startup language is always persisted as a supported value.
  persistLanguage(normalizeLanguage(i18n.resolvedLanguage || i18n.language || DEFAULT_LANGUAGE));

  return i18n;
};

void initializeI18n();

export default i18n;
